import { colors, fonts } from './constants';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();

const theme = {
  BODY_MARGIN: 0,
  COLORS: {
    BRAND: colors.BRAND_GREEN,
    TRANSPARENT: colors.TRANSPARENT,
    BASE: colors.WHITE,
    BASE_INVERTED: colors.BLACK,
    NEUTRAL_5: colors.LIGHTER_GREY,
    NEUTRAL: colors.LIGHT_GREY,
    NEUTRAL_10: colors.LINE_GREY,
    NEUTRAL_20: colors.MID_GREY,
    NEUTRAL_30: colors.DEEP_GREY,
    NEUTRAL_35: colors.BOULDER_GREY,
    NEUTRAL_40: colors.DARK_GREY,
    NEUTRAL_50: colors.LIGHT_GREY_2,
    NEUTRAL_60: colors.LIGHT_GREY_3,
    NEUTRAL_70: colors.LIGHT_GREY_4,
    NEUTRAL_80: colors.LIGHT_GREY_5,
    NEUTRAL_90: colors.SILVER_GREY,
    NEUTRAL_95: colors.LIGHT_GREY_6,
    NEUTRAL_100: colors.LIGHT_GREY_7,
    NEUTRAL_110: colors.LIGHT_GREY_8,
    NEUTRAL_120: colors.LIGHT_GREY_9,
    PRIMARY: colors.SCARLET,
    SECONDARY: colors.JADE,
    TERTIARY: colors.ACTION_BLUE,
    RED: colors.RED,
    ORANGE: colors.SUNSET_ORANGE,
    PALE_ORANGE: colors.PALE_ORANGE,
    SUCCESS: colors.FUN_GREEN,
    LA_PALMA: colors.LA_PALMA,
    ALTO: colors.ALTO,
    INFO: colors.SCIENCE_BLUE,
    DARK_BLUE: colors.DARK_BLUE,
    DARK_BLUE_2: colors.DARK_BLUE_2,
    WHITE_LILAC: colors.WHITE_LILAC,
    YELLOW: colors.YELLOW,
    WARNING: colors.BRIGHT_SUN,
    MONZA: colors.MONZA,
    ERROR: colors.MONZA,
    DANGER: colors.MONZA,
    LIMEADE: colors.LIMEADE,
    LIGHT_SILVER: colors.LIGHT_SILVER,
    DODGER_BLUE: colors.DODGER_BLUE,
    FLUSH_ORANGE: colors.FLUSH_ORANGE,
    SILVER: colors.SILVER,
    DARKER_GREY: colors.DARKER_GREY,
    DARKEST_GREY: colors.DARKEST_GREY,
    GREY_BLACK: colors.GREY_BLACK,
    CRISP_BLUE: colors.CRISP_BLUE,
    FADED_BLUE: colors.FADED_BLUE,
    MODAL_OVERLAY: colors.FADED_BLACK,
    INFO_BLUE: colors.INFO_BLUE
  },
  FONT_FACES: {
    REGULAR: fonts.GIBSON,
    LIGHT: fonts.GIBSON_LIGHT,
    SEMI_BOLD: fonts.GIBSON_SEMI_BOLD
  },
  FONT: {
    REGULAR: isOmp ? fonts.HEEBO.FAMILY : fonts.GIBSON.FAMILY,
    LIGHT: isOmp ? fonts.HEEBO.FAMILY : fonts.GIBSON_LIGHT.FAMILY,
    SEMI_BOLD: isOmp ? fonts.HEEBO_BOLD.FAMILY : fonts.GIBSON_SEMI_BOLD.FAMILY
  },
  FONT_WEIGHTS: {
    LIGHT: 100,
    SMALL: 300,
    REGULAR: 400,
    SEMI_BOLD: 600
  },
  FONT_SIZES: {
    BASE_SIZE: 16,
    BASE_UNIT: 'rem',
    get XXLARGE() {
      return `${36 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get XLARGE() {
      return `${30 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get LARGE() {
      return `${24 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get MEDIUM() {
      return `${18 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get BASE() {
      return `${16 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get SMALL() {
      return `${14 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get XSMALL() {
      return `${12 / this.BASE_SIZE}${this.BASE_UNIT}`;
    },
    get XXSMALL() {
      return `${10 / this.BASE_SIZE}${this.BASE_UNIT}`;
    }
  },
  BUTTON: {
    TEXT_TRANSFORM: 'uppercase'
  },
  LETTER_SPACING: {
    WIDE: '1.37143px',
    MEDIUM: '1.2px'
  },
  DIMENSIONS: {
    BASE_UNIT: 'px',
    BASE_RHYTHM: 6,
    get GLOBAL_MIN_WIDTH() {
      return `${this.BASE_RHYTHM * 221}${this.BASE_UNIT}`;
    },
    get LOGO_WIDTH() {
      return `${this.BASE_RHYTHM * 36}${this.BASE_UNIT}`;
    },
    get HEADER_HEIGHT() {
      return `${this.BASE_RHYTHM * 7.5}${this.BASE_UNIT}`;
    }
  },
  BP: {
    VDP_MOBILE_WH: '1145px',
    VDP_DESKTOP_WL: '1146px',
    VDP_DESKTOP_XLARGE: '2560px',
    GRIDVIEW_DESKTOP_WH: '2110px',
    GRIDVIEW_DESKTOP_WM: '1750px',
    CUSTOM_DESKTOP_SMALL: '900px',
    RETAIL_CUSTOM_MOBILE_LARGE: '720px',
    RETAIL_CUSTOM_MOBILE_SMALL: '540px',
    TIAH_LARGE: '768px',
    TIAH_DETAILS_WIDTH: '532px',
    PURCHASE_MOBILE_WIDTH: '1000px',
    PURCHASE_DESKTOP_XLARGE_WIDTH: '1001px',
    PURCHASE_MAX_WIDTH: '1140px'
  }
};

export default theme;
